module.exports = __webpack_public_path__ + "img/garyl-pro.f8a6bc09.jpg";